var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: { "background-color": _vm.schema.settings.backgroundColor } },
    [
      _c("section", { staticClass: "hpc-tiles", style: _vm.paddingStyles }, [
        _c(
          "div",
          { staticClass: "hpc__main container row" },
          [
            _vm.tileCount !== 2
              ? _c(
                  "div",
                  { staticClass: "col-12-sm col-7" },
                  _vm._l(_vm.filteredBlocks.slice(0, _vm.slicePoint), function(
                    block,
                    i
                  ) {
                    return _c("collection-layout-tiles-tile", {
                      key: block.id,
                      class: [
                        "hpc-tile--config-" + _vm.tileCount,
                        "hpc-tile--number-" + (i + 1)
                      ],
                      attrs: { block: block, settings: _vm.schema.settings }
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.filteredBlocks.slice(_vm.slicePoint, 5).length &&
            _vm.tileCount !== 2
              ? _c(
                  "div",
                  { staticClass: "col-12-sm col-5" },
                  _vm._l(_vm.filteredBlocks.slice(_vm.slicePoint, 5), function(
                    block,
                    i
                  ) {
                    return _c("collection-layout-tiles-tile", {
                      key: block.id,
                      class: [
                        "hpc-tile--config-" + _vm.tileCount,
                        "hpc-tile--number-" + (i + _vm.slicePoint + 1)
                      ],
                      attrs: { block: block, settings: _vm.schema.settings }
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm._l(_vm.filteredBlocks, function(block, i) {
              return _vm.tileCount === 2
                ? _c("collection-layout-tiles-tile", {
                    key: block.id,
                    class: [
                      "hpc-tile--config-" + _vm.tileCount,
                      "hpc-tile--number-" + (i + 1),
                      "col-12-sm",
                      "col-6"
                    ],
                    attrs: { block: block, settings: _vm.schema.settings }
                  })
                : _vm._e()
            })
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }